export default __webpack_public_path__ + "static/header-9ddfbe6cc61cfd1934de310273612ccd.svg";